import { Navigate, createBrowserRouter } from "react-router-dom";

import { ErrorElement } from "@/components/error-element";
import { AdvertisementsLayout } from "@/components/layouts/advertisements.layout";
import { CongressSettingsLayout } from "@/components/layouts/congress-settings.layout";
import { NotificationsLayout } from "@/components/layouts/notifications.layout";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";

import { FullWidthLayout } from "../components/layouts/full-width.layout";

import { AbstractPage } from "./pages/abstract";
import { AbstractDetailsPage } from "./pages/abstract-details";
import { AbstractListPage } from "./pages/abstract-list";
import { AdvertisementsSplashPage } from "./pages/advertisements-splash";
import { BreakListPage } from "./pages/break-list";
import { DashboardPage } from "./pages/dashboard";
import { MigrationLogsPage } from "./pages/migration-logs";
import { NavigationPage } from "./pages/navigation";
import { NewsPage } from "./pages/news";
import { NotificationsStatisticsPage } from "./pages/notifications-statistics";
import { SectionPage } from "./pages/section";
import { SectionDetailsPage } from "./pages/section-details";
import { SectionListPage } from "./pages/section-list";
import { SettingsPage } from "./pages/settings";
import { SocietyNavigationPage } from "./pages/society/society-navigation";

const ProtectedRoute = ({
  component,
  ...args
}: {
  component: React.ComponentType;
  [key: string]: any;
}) => {
  const Component = withAuthenticationRequired(component, args);
  return <Component />;
};

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  {
    element: <ProtectedRoute component={FullWidthLayout} />,
    errorElement: <ErrorElement />,
    children: [
      { path: "/", element: <Navigate to="/congress/details" /> },
      { path: "/congress", element: <Navigate to="/congress/details" /> },
      {
        element: <CongressSettingsLayout />,
        children: [
          { path: "/congress/details", element: <DashboardPage /> },
          { path: "/congress/sessions", element: <SectionDetailsPage /> },
          { path: "/congress/abstracts", element: <AbstractDetailsPage /> },
        ],
      },
      {
        element: <NotificationsLayout />,
        children: [
          {
            path: "/notifications",
            element: <Navigate to="/notifications/all" />,
          },
          { path: "/notifications/all", element: <NewsPage /> },
          {
            path: "/notifications/statistics",
            element: <NotificationsStatisticsPage />,
          },
        ],
      },
      {
        element: <AdvertisementsLayout />,
        children: [
          {
            path: "/advertisements",
            element: <Navigate to="/advertisements/splash" />,
          },
          { path: "/advertisements/splash", element: <AdvertisementsSplashPage /> },
        ],
      },

      { path: "/navigation", element: <NavigationPage /> },
      { path: "/society-navigation", element: <SocietyNavigationPage /> },
      // { path: "/news", element: <NewsPage /> },
      { path: "/breaks", element: <BreakListPage /> },
      { path: "/sections", element: <SectionListPage /> },
      { path: "/sections/:id", element: <SectionPage /> },
      { path: "/abstracts", element: <AbstractListPage /> },
      { path: "/abstracts/:id", element: <AbstractPage /> },
      { path: "/settings", element: <SettingsPage /> },
      { path: "/migration-logs", element: <MigrationLogsPage /> },
    ],
  },
]);

export { router };
